import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  newsEntriesUploadAttachment,
  NewsEntryAttachmentResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateNewsEntryAttachment = (
  options: UseMutationOptions<
    NewsEntryAttachmentResource,
    unknown,
    {
      file?: Blob | null;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      file: { file?: Blob | null | undefined } | undefined
    ) => {
      const result = await extractData(
        newsEntriesUploadAttachment({
          body: file,
        })
      );
      return result as unknown as NewsEntryAttachmentResource;
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['circuits'],
      });
      options.onSuccess?.(...args);
    },
  });
};
